import axios from "axios";
import { GetPriceHistoryResponseType } from "../types/chart5.type";

import { apiBase } from './apiBase';
export const getPriceHistory = (symbol: string, token: string, fr: string | undefined, to: string | undefined): Promise<GetPriceHistoryResponseType> => {
    return new Promise(async (resolve, reject) => {
        const params: any = { symbol: symbol, token: token, fr: fr, to: to };

        axios
        .get(`${apiBase()}/c5/pricehistory/`, {
                params: params,
            })
            .then((res) => {
                if (res.data.hts) {
                    resolve(res.data.hts[0].data);
                } else return;
            }
            )
            .catch((err) => {
                reject(err);
            });
    });
};